import React from 'react'

import {Compose, ComposeSettings} from "../../../../../core/components/composers/compose";
import {SideBarModuleController} from "../side-bar-module.controller";
import {SideBarModuleProps} from "../models/side-bar-module.props";
import {SideBarModuleEntityScores} from "./side-bar-module.entity-scores";
import {SideBarModuleMyScores} from "./side-bar-module.my-scores";
import {SideBarModuleAllScores} from "./side-bar-module.all-scores";
// import {SideBarModuleAthletesSidBar} from "./side-bar-module.athletes-side-bar";
import {SideBarModuleRelatedEntities} from "./side-bar-module.related-entities";
import {AD_DISPLAYS} from "../../../../../core/consts";
import classNames from "classnames";
import styles from "../styles/side-bar.module.scss";
import {ExternalAd} from "../../../../../core/components/ad/external-ad/external-ad";

export class SideBarModuleComponentProps extends SideBarModuleProps {}

export const SideBarModuleComponent = ({controller, competitorId}: SideBarModuleComponentProps) => {
  const {state, device: {isSmallView}} = controller;
  const {userCountryId, id, shouldRenderExternalAd, isAthletes} = state;

  const externalAdProps = {
    countryId: userCountryId,
    isSmallView,
    langId: state.appState.locale.language.id,
    theme: state.appState.theme,
    config: state.adConfig,
    isMock: state.appState.settings.config.adDisplay === AD_DISPLAYS.placeholders,
    className: classNames(styles.ad_container),
    controller
  }

  // const athletesSideBarProps = {
  //   controller,
  //   competitorId
  // }

  return (
    <div id={id} className={classNames({[styles.sidebar_container]: isAthletes})}>
      <SideBarModuleAllScores controller={controller}/>
      <SideBarModuleMyScores controller={controller}/>
      <SideBarModuleEntityScores controller={controller}/>
      {/*<SideBarModuleMyScoresAthletesSidBar {...athletesSideBarProps}/>*/}
      <SideBarModuleRelatedEntities controller={controller}/>
      {shouldRenderExternalAd ? <ExternalAd {...externalAdProps}/> : null}
    </div>
  );
};

const settings: ComposeSettings = {
  component: SideBarModuleComponent,
  propsType: SideBarModuleComponentProps,
  controllerType: SideBarModuleController,

  observe: true,
  websiteOnly: true,
  createModule: true,
};

export default Compose(settings);
